import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const newDataTimestamp = new Date(this.element.dataset.timestamp);
    const bodyTimestamp = new Date(document.body.dataset.timestamp);

    if (newDataTimestamp > bodyTimestamp) {
      this.element.classList.add("show");
    }
  }
}
